import { render, staticRenderFns } from "./PetitionsReviewList.vue?vue&type=template&id=83f64ee2"
import script from "./PetitionsReviewList.vue?vue&type=script&lang=js"
export * from "./PetitionsReviewList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports